import styled from 'styled-components';

export const Container = styled.div`
  padding: 25px 25px 25px 15px;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 375px) {
    flex-direction: column;
    align-items: start;
    gap: 8px;
  }
`;
export const PageTitle = styled.h3`
  font-weight: 600;
  font-size: 20px;
  color: #212529;
  padding-left: 10px;
  @media (max-width: 475px) {
    font-size: 16px;
    padding-left: 0;
  }
  @media (max-width: 386px) {
    font-size: 14px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
export const SegmentedControl = styled.div`
  display: flex;
  gap: 8px;
  padding-right: 6px;
  button {
    width: fit-content;
    height: 36px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    font-weight: 500;
    font-size: 14px;
    color: #0a0a0a;
    &.active {
      background: linear-gradient(180deg, #296bcd 0%, #245499 100%);
      color: #ffffff;
      border: none;
    }
    @media (max-width: 475px) {
      font-size: 12px;
    }
    @media (max-width: 386px) {
      font-size: 10px;
    }
    @media (max-width: 375px) {
      font-size: 14px;
    }
  }
  @media (max-width: 475px) {
    padding-right: 0;
    gap: 4px;
  }
  @media (max-width: 375px) {
    flex: 1;
    width: 100%;
    justify-content: end;
  }
`;
export const CommentEditor = styled.div`
  background: #ffffff;
  border: 0.4px solid #d4d8dd80;
  padding: 20px;
  border-radius: 10px;
  .ql-container {
    padding-bottom: 0;
  }
  .ql-toolbar {
    padding: 12px 22px;
  }
  .ql-editor {
    min-height: 55px;
  }
`;
export const CommentEditorTitle = styled.h3`
  font-weight: 600;
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 5px;
`;
